<div class="filter-container">
  <form [formGroup]="searchForm" (submit)="search()" class="search-form">
    <mat-form-field appearance="outline">
      <mat-label>Search By</mat-label>
      <mat-select aria-label="Search By" [formControlName]="'filterType'">
        @for (filter of searchFilters; track filter) {
          <mat-option [value]="filter.value">{{filter.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Search Terms</mat-label>
      <input matInput [formControlName]="'filterValue'">
    </mat-form-field>
  </form>
  <div class="buttons-container">
    <button class="filter-button" (click)="search()" type="submit" mat-raised-button color="primary">SEARCH</button>
    <button class="filter-button" (click)="reset()" type="submit" mat-stroked-button color="primary">RESET</button>
  </div>
</div>

<div class="sort-container">
  <mat-form-field appearance="outline">
    <mat-label>Sort By</mat-label>
    <mat-select aria-label="Sort By" (selectionChange)="sortAppointments($event)" [(ngModel)]="sortOption">
      @for (option of sortOptions; track option) {
        <mat-option [value]="option">{{option}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

@if (appointments?.length && !isLoading) {
  @for (soa of appointments; track soa) {
    <div>
      <app-soa-card [agentEsoaLink]="agentEsoaLink" [soa]="soa"></app-soa-card>
    </div>
  }
}

@if (!appointments?.length && !isLoading) {
  <div class='margin-content red-text'>No SOAs found</div>
}

@if (isLoading) {
  <div class='margin-content'><mat-spinner [diameter]="80"></mat-spinner></div>
}
